/**
 * Default surface sizing for product dropdown menus (view settings, row ⋯, column menus, etc.).
 *
 * Uses **pure CSS** (`w-max` + `min-w-*` + `max-w-*`) so width follows labels and shortcuts
 * without **ResizeObserver** or layout thrash.
 *
 * Override when you need a fixed rail, for example:
 * - `className="w-20"` — page-size picker in `DataTablePaginated`
 * - `className="w-(--radix-dropdown-menu-trigger-width) min-w-60"` — account / identity menus
 * - `SHELL_IDENTITY_MENU_SURFACE_CLASS` — school / product switchers (fixed width + wrap)
 *
 * **Windows mid-scale note:** OS display scaling (125%/150%) shrinks CSS viewport width; it
 * does **not** set `visualViewport.scale`. Prefer fixed/max widths + wrap over `!w-max` for
 * shell identity menus so long labels do not push the menu wider on scaled laptops.
 */
export const DROPDOWN_MENU_CONTENT_SURFACE_CLASS =
  "min-w-52 w-max max-w-[min(24rem,calc(100vw-2rem))]" as const

/**
 * School / product switcher menus — stable width so long names wrap (≤2 lines in the
 * summary row) instead of growing the popover. Cap keeps the menu inside the viewport
 * at Windows 125–150% scale and browser zoom.
 */
export const SHELL_IDENTITY_MENU_SURFACE_CLASS =
  "w-72 max-w-[min(100vw-2rem,18rem)]" as const
